import { render, staticRenderFns } from "./breakageDialog.vue?vue&type=template&id=049dca4f&scoped=true"
import script from "./breakageDialog.vue?vue&type=script&lang=js"
export * from "./breakageDialog.vue?vue&type=script&lang=js"
import style0 from "./breakageDialog.vue?vue&type=style&index=0&id=049dca4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049dca4f",
  null
  
)

export default component.exports